module.exports = __webpack_public_path__ + "img/rnd2.599cf68e.jpg";